<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="aH" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 19.8 19.8" style="enable-background:new 0 0 19.8 19.8;" xml:space="preserve">
<style type="text/css">
	.st0H{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_HALP);}
	.st1H{fill-rule:evenodd;clip-rule:evenodd;fill:#2684FF;}
</style>
<radialGradient id="SVGID_1_HALP" cx="9.9116" cy="2459.2297" r="7.968" gradientTransform="matrix(1 0 0 1 0 -2449.3298)" gradientUnits="userSpaceOnUse">
	<stop  offset="0.43" style="stop-color:#0052CC"/>
	<stop  offset="0.84" style="stop-color:#1B75F0"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</radialGradient>
<path class="st0H" d="M15.5,4.2c1.1,1.1,1.9,2.6,2.2,4.1c0.2,1.5,0.2,3.1-0.5,4.6c-0.6,1.4-1.6,2.7-2.9,3.6c-1.4,0.9-2.9,1.4-4.4,1.4
	s-3.1-0.5-4.4-1.4c-1.4-0.9-2.3-2.1-2.9-3.6c-0.6-1.4-0.8-3-0.5-4.6s1-3,2.2-4.1C5,3.5,5.9,2.9,6.9,2.5c1-0.4,2-0.6,3-0.6
	s2.1,0.2,3,0.6C14,2.9,14.8,3.6,15.5,4.2z M5.7,14.2L5.7,14.2z M11.9,6.7L13.5,5c-1-0.8-2.3-1.2-3.6-1.2S7.3,4.2,6.3,5L8,6.6
	L6.6,7.8L5,6.3c-0.8,1-1.2,2.3-1.2,3.6s0.4,2.6,1.2,3.6L6.5,12l1.2,1.2l-1.4,1.6c1,0.8,2.3,1.2,3.6,1.2s2.6-0.4,3.6-1.2L11.7,13
	l1.1-1.1l1.7,1.7c0.8-1,1.2-2.3,1.2-3.6s-0.4-2.6-1.2-3.6L13,8C13.1,7.9,11.9,6.7,11.9,6.7z"/>
<path class="st1H" d="M9.9,5.9c-0.8,0-1.6,0.2-2.2,0.6C7.2,6.9,6.5,7.7,6.2,8.4C5.9,9.1,5.9,9.9,6,10.7c0.2,0.8,0.5,1.4,1,2
	c0.6,0.6,1.3,0.9,2,1c0.8,0.2,1.6,0.1,2.3-0.2c0.7-0.2,1.4-0.8,1.8-1.4c0.5-0.6,0.6-1.4,0.6-2.2c0-1-0.4-2.1-1.2-2.8
	C12,6.4,11,5.9,9.9,5.9z M9.9,12.1c-0.5,0-0.9-0.2-1.2-0.3c-0.3-0.2-0.6-0.6-0.8-1S7.7,9.9,7.7,9.5C7.8,9,8.1,8.7,8.4,8.4
	c0.3-0.3,0.7-0.5,1.1-0.6c0.5-0.1,0.9-0.1,1.3,0.1s0.8,0.5,1,0.8c0.2,0.3,0.3,0.8,0.3,1.2c0,0.3-0.1,0.6-0.2,0.9
	c-0.1,0.2-0.2,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.7,0.5C10.5,12.1,10.2,12.1,9.9,12.1z"/>
</svg>
